import Toast from './Toast'
import { useToastNotifications } from '../hooks/useToastNotifications'

export function ToastCenter() {
  const { toasts, dismiss } = useToastNotifications()

  if (toasts.length === 0) return null

  return (
    <>
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          message={toast.message}
          itemName={toast.itemName}
          type={toast.type}
          duration={toast.duration}
          action={toast.action}
          onClose={() => dismiss(toast.id)}
        />
      ))}
    </>
  )
}
